import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"],
  _excluded2 = ["data"];
/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.video.conference.component.rpc.ui.service.v1.WebinarFormsAppStatusChirpUIService
 */

import { useQuery, useLazyQuery } from 'data-fetching-client';
import * as Queries from './WebinarFormsAppStatusChirpUIService.dfc.new';
export function useAppStatusQuery(options) {
  const _useQuery = useQuery(Queries.APP_STATUS_QUERY, options),
    {
      data
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    const newData = {
      appStatus: data === null || data === void 0 ? void 0 : data.result
    };
    return Object.assign({
      data: newData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useAppStatusLazyQuery(options) {
  const [getter, _ref] = useLazyQuery(Queries.APP_STATUS_QUERY, options);
  const {
      data
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded2);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    const newData = {
      appStatus: data === null || data === void 0 ? void 0 : data.result
    };
    return [getter, Object.assign({
      data: newData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}